var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"format-reference-tag-filter-root"},[_c('span',[_vm._v("タグ")]),_vm._v(" "),_c('string-filter',{model:{value:(_vm.tag),callback:function ($$v) {_vm.tag=$$v},expression:"tag"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }